export default __webpack_public_path__ + "static/media/automation-icon.bfaf396d.svg";